import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectItem as SelectItemView, Props } from '../../components/SelectItem';
import card from './static/img/card.svg';

export const SelectItem: React.FC<Omit<Props, 'icon' | 'name'>> = (props) => {
  const { t } = useTranslation('toCard');
  const { currency } = props.instrument;
  return (
    <SelectItemView
      {...props}
      icon={card}
      name={currency === 'USD' ? t('Dollars to a bank card') : t('To any Russian card')}
    />
  );
};
